<ng-container *ngIf="machine">
  <h4><p class="text-center">Onderhouds geschiedenis van {{machine.name}}</p></h4>

  <p-dataTable [value]="maintenances" [rows]="10" [paginator]="true" [pageLinks]="5"
               scrollable="true" selectionMode="single" [(selection)]="selectedMaintenance">
    <p-column field="maintenance.created" header="Datum" [sortable]="true">
      <ng-template let-col let-maintenances="rowData" let-ri="rowIndex" pTemplate="body">
        <span>{{maintenances.maintenance.created| date:'d-M-y'}}</span>
      </ng-template>
    </p-column>
    <p-column field="maintenance.user.name" header="Monteur" [sortable]="true"></p-column>
  </p-dataTable>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/pages/machine/history/machine.history.component.html